const transparentPixel = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

// replace the image by the error image if not found
module.exports = function () {
    return {
        restrict: 'A',
        link(scope, element, attrs) {
            element.bind('error', function () {
                attrs.$set('src', attrs.olyErrorSrc && attrs.olyErrorSrc.length > 0 ? attrs.olyErrorSrc : transparentPixel);
            });
        }
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/error-src/error-src-directive.js
 **/